<template>
  <b-card no-body>
    <b-card-header>
      <b-card-title>{{ $t('Quarter Applicant Stat') }}</b-card-title>
    </b-card-header>
    <b-table
      :items="data"
      responsive
      :fields="fields"
      class="mb-0"
      style="max-height: 550px"
    >
      <template #head()="data">
        {{ $t(data.label) }}
      </template>

      <template #cell(name)="{ item }">
        {{ item.code }} - {{ $langName(item.name) }}
      </template>
      <template #cell(usr_org_count)="data">
        <span class="font-weight-bolder">{{ data.value }}</span>
      </template>
    </b-table>
  </b-card>
</template>
<script>
import {
  BCard, BCardHeader, BCardTitle, BTable,
} from 'bootstrap-vue'

export default {
  name: 'DirectionStat',
  components: {
    BCardHeader, BCardTitle, BTable, BCard,
  },
  props: {
    isOtm: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      loading: true,
      data: null,
    }
  },
  created() {
    this.loading = true
    this.$store.dispatch(`statistic/get${this.isOtm ? 'Org' : 'Min'}QuarterApplicantStat`).then(({ data }) => {
      let res = []
      data.forEach(({ admission_year, quarters }) => {
        res = res.concat(quarters.map(({ quarter, all, success }) => ({
          admission_year,
          quarter,
          all,
          success,
        })))
      })
      this.data = res
      this.loading = false
    })
  },
  setup() {
    const fields = [
      { key: 'admission_year', label: 'Year' },
      { key: 'quarter', label: 'Quarter' },
      { key: 'all', label: 'All' },
      { key: 'success', label: 'Success' },
    ]
    return {
      fields,
    }
  },
}
</script>
